import { routes } from "pages/routes";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import AdminShell, { AdminNavGroup } from "components/adminUi/AdminShell";
import {
  AsyncCustomerServiceMonitoring,
  AsyncCustomerServiceSession,
} from "./asyncPages";
import RestrictedRoute from "./components/RestrictedRoute";
import SignOut from "./components/SignOut";

// Customer service gets the adminUi shell (which applies .admin-v2, so the
// --adm-* driven screens render on real tokens instead of their fallbacks)
// with a nav scoped to what the role can actually reach. Before this shell,
// CS had no navigation at all — the only way out was the browser back button.
const CS_NAV: AdminNavGroup[] = [
  {
    label: "Customer service",
    items: [
      { label: "Monitoring", to: routes.customerServiceRoot.path(), glyph: "◉" },
      { label: "Sign out", to: routes.signOut.path(), glyph: "⏻" },
    ],
  },
];

export default function CustomerServiceRoutes() {
  const location = useLocation();
  return (
    <Routes key={location.pathname}>
      <Route
        path={routes.root.pattern}
        element={<Navigate to={routes.customerServiceRoot.path()} replace />}
      />

      <Route element={<AdminShell groups={CS_NAV} />}>
        <Route
          path={routes.customerServiceSessionDetails.pattern}
          element={
            <RestrictedRoute
              Component={AsyncCustomerServiceSession}
              permissions="customer-service"
            />
          }
        />

        <Route
          path={routes.customerServiceRoot.pattern}
          element={
            <RestrictedRoute
              Component={AsyncCustomerServiceMonitoring}
              permissions="customer-service"
            />
          }
        />
      </Route>

      <Route path={routes.signOut.pattern} element={<SignOut />} />

      <Route
        path="*"
        element={<Navigate to={routes.customerServiceRoot.path()} replace />}
      />
    </Routes>
  );
}
